import { render, staticRenderFns } from "./UserBindDevices.vue?vue&type=template&id=9534961e&scoped=true"
import script from "./UserBindDevices.vue?vue&type=script&lang=js"
export * from "./UserBindDevices.vue?vue&type=script&lang=js"
import style0 from "./UserBindDevices.vue?vue&type=style&index=0&id=9534961e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9534961e",
  null
  
)

export default component.exports